// src/services/mqttService.ts
import mqtt from "mqtt/dist/mqtt"
import { Notification } from 'element-ui';

const MqttService = {
  mqttClient: null,
  mqttStatus: 'disconnected',
  userId: null,
  Callback: null,

  // 初始化 MQTT 连接
  initMqtt(url, options = {}) {
    return new Promise((resolve, reject) => {
      try {
        this.mqttClient = mqtt.connect(url, {
          clean: true,
          connectTimeout: 10000,
          reconnectPeriod: 10000,
          ...options
        });

        this.mqttClient.on('connect', () => {
          this.mqttStatus = 'connected';
          console.log('MQTT connected');
          resolve(this.mqttClient);
        });

        this.mqttClient.on('error', (error) => {
          this.mqttStatus = 'error';
          console.error('MQTT error:', error);
          reject(error);
        });

        this.mqttClient.on('reconnect', () => {
          this.mqttStatus = 'reconnecting';
          console.log('MQTT reconnecting...');
        });

        this.mqttClient.on('close', () => {
          this.mqttStatus = 'disconnected';
          console.log('MQTT disconnected');
        });

        // 全局消息处理
        this.mqttClient.on('message', (topic, message) => {
          try {
            if (topic === `message/notify/${this.userId}`) {
              const msg = message.toString();
              const parsedMsg = JSON.parse(msg);
            
              this.handleNotification(parsedMsg);
              if (typeof this.Callback !== 'function') return;
              this.Callback(parsedMsg);
            }
          } catch (e) {
            this.handleNotification({ title: '新消息', msg: msg });
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  },

  // 订阅主题
  subscribeToUserTopic(user) {
    if (!this.mqttClient || !user) return;

    this.userId = user.userId;
    const topic = `message/notify/${this.userId}`;

    if (this.mqttStatus === 'connected') {
      console.log(`Subscribing to ${topic}...`);

      this.mqttClient.subscribe(topic, { qos: 0 }, (err) => {
        if (err) {
          console.error('Subscription error:', err);
        } else {
          console.log(`Subscribed to ${topic}`);
        }
      });
    }
  },

  // 取消订阅
  unsubscribeFromUserTopic() {
    if (!this.mqttClient || !this.userId) return;

    const topic = `message/notify/${this.userId}`;
    this.mqttClient.unsubscribe(topic, (err) => {
      if (err) {
        console.error('Unsubscription error:', err);
      } else {
        console.log(`Unsubscribed from ${topic}`);
        this.userId = null;
      }
    });
  },

  // 处理通知
  handleNotification(message) {
    Notification({
      title: message.title || '通知',
      message: message.msg || '您有一条新消息',
      type: 'info',
      position: 'top-right',
      duration: 10000
    });
  },

  // 接收外部传递的函数
  onMessage(callback) {
    if (typeof callback !== 'function') return;
    this.Callback = callback;
  },

  // 断开连接
  disconnectMqtt() {
    if (this.mqttClient) {
      this.unsubscribeFromUserTopic();
      this.mqttClient.end();
      this.mqttClient = null;
      this.mqttStatus = 'disconnected';
    }
  }
};

export default MqttService;
